export enum OverrideField {
  ProductionFacility = 'productionFacility',
  DaysInLab = 'daysInLab',
}
